var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"36","cy":"36","r":"34.5","fill":"none","stroke":"inherit","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"3","key":0}),React.createElement("path",{"fill":"none","stroke":"inherit","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","d":"M36 6.65V36h14.56","key":1})]);
}

Clock.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 72 72"};

module.exports = Clock;

Clock.default = Clock;
